module.exports = __webpack_public_path__ + "static/img/complete.3bc99ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete.png
// module id = WN6W
// module chunks = 1